import styled from "styled-components";

export const AuthWarpper = styled.section`
  display: flex;
  flex-wrap: wrap;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.light};

  .lang-btn {
    position: fixed;
    top: 1rem;
    ${({ theme }) => theme.start}: 1rem;
    z-index: 10;
    color: ${({ theme }) => theme.dark};
    background-color: transparent;
    box-shadow: none;
  }

  .auth-block {
    width: 100%;
    padding: 1rem;
    margin-block: 2rem;

    @media only screen and (min-width: 992px) {
      width: 50%;
      padding: 4rem;
    }

    .content {
      width: 100%;
      max-width: 400px;
      padding: 2.5rem;
      background-color: ${({ theme }) => theme.light};
      border-radius: 16px;
      border: 1px solid ${({ theme }) => theme.border};
      box-shadow: ${({ theme }) => theme.shadow};
    }
  }

  .auth-bg {
    display: none;

    @media only screen and (min-width: 992px) {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 50%;
      background: linear-gradient(
        135deg,
        ${({ theme }) => theme.primary},
        ${({ theme }) => theme.dark}
      );
      border-radius: 0 12px 12px 0;
      position: relative;
      padding: 2rem;

      .auth-gif {
        width: 80%;
        max-width: 480px;
        border-radius: 12px;
      }
    }
  }
`;
